import { render, staticRenderFns } from "./billInfo.vue?vue&type=template&id=4baa6b35&scoped=true"
import script from "./billInfo.vue?vue&type=script&lang=js"
export * from "./billInfo.vue?vue&type=script&lang=js"
import style0 from "./billInfo.vue?vue&type=style&index=0&id=4baa6b35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baa6b35",
  null
  
)

export default component.exports